module.exports = __webpack_public_path__ + "assets/350174d428c8bc0d7fb16df5355b857b.mp3";